import script from "./Honor.vue?vue&type=script&lang=ts&setup=true"
export * from "./Honor.vue?vue&type=script&lang=ts&setup=true"

import "./Honor.vue?vue&type=style&index=0&id=7a408c61&lang=less&scoped=true"

import exportComponent from "/Volumes/未命名/repos/qll-web-work/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a408c61"]])

export default __exports__